/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'document': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g clip-path="url(#svgicon_document_a)"><path pid="0" d="M15.414 2H6c-1.103 0-2 .898-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V6.586L15.414 2ZM7 12h8v2H7v-2Zm10 6H7v-2h10v2ZM14 8V3l5 5h-5Z" _fill="#fff"/></g><defs><clipPath id="svgicon_document_a"><path pid="1" _fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs>'
  }
})
